import { useTranslations } from "next-intl";
import sizeEquivalenceTables from "@utils/sizeEquivalenceTables";
import classNames from "classnames";

const customer = process.env.NEXT_PUBLIC_CUSTOMER;

function SizeEquivalenceTable({ sizeType }) {
  const t = useTranslations("common");

  if (sizeType !== "size_pants") return null;

  return (
    <table
      className="table mt-5 text-center"
      style={{ tableLayout: "fixed", width: "100%" }}
    >
      <thead className="pt-5">
        <tr className="pt-3">
          <th className="border-0 bg-transparent">
            {t("size_reference_table_title.size_pants_length")}
          </th>
          <th className="border-0 bg-transparent">
            {t("size_reference_table_title.size_ref_length")}
          </th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(sizeEquivalenceTables[customer].size_pants_length).map(
          ([key, value], index) => {
            const bg = index % 2 === 0 ? "bg-white" : "bg-light-gray";

            return (
              <tr
                key={key}
                className={classNames("border-0", bg)}
              >
                <td className="border-0 text-center">{key}</td>
                <td className="border-0 text-center">
                  {t(`size_reference_table_length.${value}`)}
                </td>
              </tr>
            );
          },
        )}
      </tbody>
    </table>
  );
}

export default SizeEquivalenceTable;
